import React from 'react';
import { PieChart } from 'react-minimal-pie-chart';
import nodata from 'assets/Images/nodata.png';
import { FlexBox, Text } from '@eltoro-ui/components';
import 'Pages/CampaignDashboard/components/Charts/Charts.scss';

type AdsProps = {
  data: {
    inReview: number;
    active: number;
    completed: number;
  };
};
const Ads = ({ data }: AdsProps) => {
  const adsSchema = {
    pieData: [
      { title: 'In Review', value: data?.inReview || 0, color: '#E2E0E0' },
      { title: 'Active', value: data?.active || 0, color: '#52C41A' },
      { title: 'Completed', value: data?.completed || 0, color: '#647DFF' },
    ],
    context: [
      {
        value: data?.inReview || 0,
        label: `In Review (${data?.inReview || 0})`,
        backgroundColor: '#E2E0E0',
      },
      {
        value: data?.active || 0,
        label: `Active (${data?.active || 0})`,
        backgroundColor: '#52C41A',
      },
      {
        value: data?.completed || 0,
        label: `Completed (${data?.completed || 0})`,
        backgroundColor: '#647DFF',
      },
    ],
  };
  const adsData = Object.values(data).every(value => !value);

  return (
    <div className="adType">
      <Text on="white" UNSAFE_style={{ color: '#757575', paddingBottom: '54px' }} weight="bold">
        Ads ({data.active + data.inReview + data.completed})
      </Text>
      <div className="adType__ad-type">
        <div className="adType__ad-type-text">
          {adsSchema.context.map(({ value, label, backgroundColor }) => {
            return (
              <FlexBox key={`${label}-${value}`} alignItems="center">
                <div
                  className="adType__ad-box"
                  style={{
                    backgroundColor,
                  }}
                />
                <Text on="white" UNSAFE_className="adType__label">
                  {label}
                </Text>
              </FlexBox>
            );
          })}
        </div>
        {adsData ? (
          <div className="noData-ad-type">
            <img style={{ width: '54px' }} src={nodata} alt="nodata" />
            <Text on="tertiary-300" UNSAFE_className="noDataText">
              No Ads to Display
            </Text>
          </div>
        ) : (
          <PieChart
            className="adType__pieChart"
            lineWidth={20}
            labelPosition={0}
            data={adsSchema.pieData}
          />
        )}
      </div>
    </div>
  );
};

export default Ads;
